import Axios from "axios";

export const getProductCategoriesApi = ({ authToken, deviceId }) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURL + "utility/v1/product/categories",
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const searchProductsApi = ({
    authToken,
    deviceId,
    userId,
    merchantId,
    currencyType,
    search,
    isExternal,
    sortbyNumber,
    sortNumber,
    merchantIdProduct,
    storeId,
    page,
    nRecords,
    productName,
    ...restParams
}) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURLNew + "redeem/product/search",
            params: {
                userId: userId,
                merchantId: merchantId,
                productName: productName || search,
                sort: sortNumber,
                sortBy: sortbyNumber,
                // productCode : '',
                productType: restParams.productType,
                currencyId: currencyType,
                isExternal: isExternal,
                merchantIdProduct: merchantIdProduct,
                page: page || 0,
                nRecords: nRecords || 10,
                storeId: storeId,
                minPrice: restParams.minPrice,
                maxPrice: restParams.maxPrice
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const viewProductApi = ({ authToken, deviceId, userId, merchantId, id, nRecords, page }) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURLNew + "redeem/product/view",
            params: {
                userId: userId,
                merchantId: merchantId,
                productId: id,
                nRecords: nRecords,
                page: page
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const updateProductApi = ({ authToken, deviceId, userId, merchantId, id, data }) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURLNew + "redeem/product/update",
            data: {
                userId: userId,
                merchantId: merchantId,
                productId: id,
                productCode: data.productCode,
                productName: data.productName,
                description: data.description,
                productType: data.productType,
                productTypeLabel: data.productTypeLabel,
                categoryId: data.categoryId,
                productImage: data.productImage,
                stock: data.stock,
                basePrice: data.basePrice,
                pointsEarned: data.pointsEarned,
                isAllMerchantExchangePoint: -1,
                detectAccountExchangePoint: 4,
                voucherValue: data.voucherValue,
                isMarketplace: data.isMarketplace,
                productDetails: data.productDetails,
                storeId: data.storeId,
                isShowAggregator: data.isShowAggregator,
                brandName: data.brandName
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const createProductApi = ({ authToken, deviceId, userId, merchantId, data }) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURLNew + "redeem/product/create",
            data: {
                userId: userId,
                merchantId: merchantId,
                productId: data.productId,
                productCode: data.productCode,
                productName: data.productName,
                description: data.description,
                productType: data.productType,
                productTypeLabel: data.productTypeLabel,
                categoryId: data.categoryId,
                productImage: data.productImage,
                stock: data.stock,
                basePrice: data.basePrice,
                pointsEarned: data.pointsEarned,
                isAllMerchantExchangePoint: -1,
                detectAccountExchangePoint: 4,
                voucherValue: data.voucherValue,
                isMarketplace: data.isMarketplace,
                productDetails: data.productDetails,
                storeIdList: data.storeIdList,
                isShowAggregator: data.isShowAggregator,
                brandName: data.brandName
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const deleteProductApi = ({ authToken, deviceId, userId, merchantId, id }) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURLNew + "redeem/product/delete",
            data: {
                userId: userId,
                merchantId: merchantId,
                productId: id
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const addStockApi = ({ authToken, deviceId, userId, merchantId, data }) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURLNew + "redeem/product/update/stock",
            data: {
                userId: userId,
                merchantId: merchantId,
                productId: data.productId,
                additionalStock: data.additionalStock,
                productDetails: data.productDetails
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};
